// ─────────────────────────────────────────────────────────────────────────────
// Student logins are usernames. Supabase auth only knows email addresses, so a
// username is stored as `<username>@students.gibberfish.app` — an address that
// is never written to. The student-accounts edge function creates them with the
// SAME domain; change one, change both.
// ─────────────────────────────────────────────────────────────────────────────

export const STUDENT_EMAIL_DOMAIN = 'students.gibberfish.app';
export const USERNAME_RE = /^[a-z0-9_.]{3,24}$/;

export const normaliseUsername = (s: string) => s.trim().toLowerCase();

/** What signInWithPassword gets: an email as typed, or a username mapped to its address. */
export function loginEmail(identifier: string): string {
  const id = identifier.trim();
  return id.includes('@') ? id : `${normaliseUsername(id)}@${STUDENT_EMAIL_DOMAIN}`;
}

export const isStudentEmail = (email: string | undefined | null) =>
  !!email && email.toLowerCase().endsWith(`@${STUDENT_EMAIL_DOMAIN}`);
